/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sklik_SetupInputs */

const cs_sklik_setup = /** @type {(inputs: Sklik_SetupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Připojit Sklik`)
};

const en_sklik_setup = /** @type {(inputs: Sklik_SetupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connect Sklik`)
};

/**
* | output |
* | --- |
* | "Connect Sklik" |
*
* @param {Sklik_SetupInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const sklik_setup = /** @type {((inputs?: Sklik_SetupInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sklik_SetupInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sklik_setup(inputs)
	return cs_sklik_setup(inputs)
});